export function absoluteFromHost(host: string, path?: string | null): string | undefined {
    if (!path?.trim()) return undefined;
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    const normalized = path.startsWith('/') ? path : `/${path}`;
    const base = host.replace(/\/$/, '');
    if (!base) return normalized;
    return `${base}${normalized}`;
}
